module.exports = __webpack_public_path__ + "media/assets/images/logo/on-logo--black-eb4d89e7863c9280545ab2429484212c.svg";